<template>
	<user-layout hasBack backLink="/personnel/index">
		<div class="max-w-[500px] mx-auto py-6">
			<form-section
				:form="form"
				:errors="errors"
				:departments="departmentOptions"
				:positions="positionOptions"
				:userGroups="userGroupOptions"
				:offices="officeOptions">
				<div class="col-span-2">
					<div class="flex items-center justify-end w-full space-x-3">
						<a @click="router.replace('/personnel/index/')">
							<button-component btnWidth="quinary">Cancel</button-component>
						</a>

						<button-component btnWidth="primary" @click="save()" v-if="canCreate()">Save Changes</button-component>
					</div>
					<confirmation-modal
						:typeTwo="true"
						:show="showConfirmation"
						@cancel="showConfirmation = false"
						@confirm="
							showSuccess = true;
							showConfirmation = false;
						"
						cancel-text="Cancel"
						action-text="Confirm"
						title="Save Record"
						content="Are you sure you wish to save this record?" />
					<success-modal
						:show="showSuccess"
						@confirm="redirectSuccess()"
						action-text="Close"
						title="Record Saved!"
						:content="successMessage" />
                    <error-modal :show="showError" :content="errors?.message" />    
				</div>
			</form-section>
		</div>
		<page-loader :show="loading" />
	</user-layout>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import FormSection from "./FormSection.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { useRouter } from "vue-router";
import Personnels from "@/classes/Personnels";
import { errorResponse } from "@/helpers/errorMessage";
import PageLoader from "@/components/loaders/PageLoader.vue";
import { RoleTypes } from "../enums/RoleTypes";
import ErrorModal from "@/components/modals/ErrorModal.vue";

const router = useRouter();
const loading = ref<boolean>(false);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const successMessage = ref<string>("Data has been successfully saved!");
const form = ref<{
	email: string;
	last_name: string;
	first_name: string;
	middle_name: string;
	mobile_number: string;
	home_address: string;
	is_temporary: boolean;
	department_id: any;
	office_id: any;
	role_id: any;
	position_id: any;
    is_active: boolean | null,
}>({
	email: "",
	last_name: "",
	first_name: "",
	middle_name: "",
	mobile_number: "",
	home_address: "",
	is_temporary: false,
	department_id: "",
	office_id: "",
	position_id: "",
	role_id: "",
    is_active: null,
});
const errors = ref<any>();
const officeOptions = ref<[]>([]);
const userGroupOptions = ref<[]>([]);
const positionOptions = ref<[]>([]);
const departmentOptions = ref<[]>([]);
const userRole = ref();
const showError = ref(false);

const save = (): void => {
	loading.value = true;
    showError.value = false;
	Personnels.store(form.value)
		.then((response: any) => {
			loading.value = false;
			showConfirmation.value = true;
			successMessage.value = response.data.message;
		})
		.catch((error: any) => {
			loading.value = false;
			(errors.value = errorResponse(error.response?.data?.errors || error.response?.data?.message))
            if (error.response.status == 403) {
                showError.value = true;
            }
		});
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.replace("/personnel/index");
};

const canCreate = () => {
    let hasAccess = false;
    if (userRole.value?.role_id == RoleTypes.SUPERADMIN 
    || userRole.value?.role_id == RoleTypes.SUPERADMIN_IT 
    || userRole.value?.role_id == RoleTypes.OFFICE_ADMIN) {
        hasAccess = true;
    }

    return hasAccess;
}

onMounted(() => {
    userRole.value =  JSON.parse(localStorage.getItem('user')); 
	Personnels.create()
		.then((response: any) => {
			officeOptions.value = response.data.offices;
			positionOptions.value = response.data.positions;
			userGroupOptions.value = response.data.userGroups;
			departmentOptions.value = response.data.departments;
		})
		.catch((error: any) => console.log(error));
});
</script>
